
export * from "./services/administrator-service";
